import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { ConfigModule, I18nModule } from '@spartacus/core'
import { DatePickerComponent } from './date-picker.component'
import { environment } from '../../../../environments/environment'

@NgModule({
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['sharedComponents'],
        },
      },
    }),
  ],
  declarations: [DatePickerComponent],
  exports: [DatePickerComponent],
})
export class DatePickerModule {}
